import { operatorApiFetch } from './apiService';

export const outOfStockProductService = {
  getRecords: async (params) => {
    const response = await operatorApiFetch('orders/out_of_stock_products', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  getIds: async (params) => {
    const response = await operatorApiFetch('orders/out_of_stock_products_all', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  getOrders: async (productId, filters = {}) => {
    const response = await operatorApiFetch('orders/out_of_stock_product_orders', {
      method: 'POST',
      body: JSON.stringify({ product_id: productId, ...filters })
    });
    return response.json();
  }
};

export default outOfStockProductService;
